export default __webpack_public_path__ + "static/media/course3.2f6b11a4.png";